import { render, staticRenderFns } from "./DialogSuppressionNc.vue?vue&type=template&id=1afa700e"
import script from "./DialogSuppressionNc.vue?vue&type=script&lang=js"
export * from "./DialogSuppressionNc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports